import React from "react";
import Input from "@material-ui/core/Input";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			minWidth: 250
		}
	}
};

export default function LookupFilter(props) {
	const { columnDef, onFilterChanged } = props;

	const defaultValue = columnDef.multiple ? [] : "";
	const singleRender = selected => columnDef.lookup[selected];
	const multipleRender = selecteds => {
		return selecteds.map(selected => columnDef.lookup[selected]).join(", ");
	};

	const [value, setValue] = React.useState(
		() => columnDef.tableData.filterValue ?? columnDef.filterValue ?? defaultValue
	);

	React.useEffect(() => {
		if (value || value !== "") {
			onFilterChanged(columnDef.tableData.id, value);
		}
	}, [value]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<FormControl style={{ minWidth: 120, maxWidth: 200 }}>
			<InputLabel htmlFor="select-multiple-checkbox">
				{columnDef.filterPlaceholder}
			</InputLabel>
			<Select
				value={value}
				onChange={event => setValue(event.target.value)}
				input={<Input id="select-multiple-checkbox" />}
				renderValue={selected =>
					columnDef.multiple ? multipleRender(selected) : singleRender(selected)
				}
				MenuProps={MenuProps}
				multiple={columnDef.multiple}
			>
				<MenuItem value={null}>
					<em>Nincs</em>
				</MenuItem>
				{Object.keys(columnDef.lookup).map(key => (
					<MenuItem key={key} value={key}>
						{columnDef.multiple && (
							<Checkbox
								checked={
									columnDef.tableData?.filterValue.indexOf(key.toString()) > -1 || false
								}
							/>
						)}
						<ListItemText primary={columnDef.lookup[key]} />
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
}
